export default __webpack_public_path__ + "static/media/m_engineering_card19_2.b33b70fa.png";